// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".avatar-delete-btn[data-v-eae9cc18]{margin-top:var(--space-smaller);margin-bottom:var(--space-smaller)}", "",{"version":3,"sources":["/app/app/javascript/dashboard/components/widgets/forms/AvatarUploader.vue"],"names":[],"mappings":"AACA,oCACE,+BAAA,CACA,kCAAA","file":"AvatarUploader.vue","sourcesContent":["\n.avatar-delete-btn {\n  margin-top: var(--space-smaller);\n  margin-bottom: var(--space-smaller);\n}\n"]}]);
// Exports
module.exports = exports;
